$(window).resize(function(){
	equalizeHeight('.related-media .gallery-caption');
	equalizeHeight('.galleries-carousel .gallery-caption');
});


function gallery_type_filters($this){
	PCKRY = false;
	$('.galleries-filter .right_filters li').removeClass('active');
	$this.addClass('active');
	$('.galleries.partial').data('gallery_type',$this.data('filter'));
	load_partial($('.galleries.partial')); 
	return false;
}



var FeaturedGalleries = {
	init:function(){
		$('.featured-galleries .galleries-carousel').on('init',function(){
			$('.featured-galleries').removeClass('loading');
		});
		var featured_galleries_carousel = $('.featured-galleries .galleries-carousel').slick({
			autoplay:true,
  			autoplaySpeed:5000, 
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite:true,
			arrows:false
		});

		featured_galleries_carousel.on('afterChange', function(){
			var index = Number($('.featured-galleries .galleries-carousel .slick-slide.slick-current').data('slick-index'))+1;
			if(index < 10){
				index = "0" + index;
			}
			$('.featured-galleries .controls .counter .current').html(index);
		});


		$('.featured-galleries .controls .slick-prev').click(function(){
			featured_galleries_carousel.slick('slickPrev');
			return false;
		});
		$('.featured-galleries .controls .slick-next').click(function(){
			featured_galleries_carousel.slick('slickNext');
			return false;
		});
	}
};